import { Component, OnInit } from '@angular/core';
import { SlideModel } from 'src/app/models/common/slide.model';
import { ApiService } from 'src/app/services/api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
    selector: 'app-slider',
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.scss'],
    standalone: false
})
export class SliderComponent implements OnInit {

  public slides: Array<SlideModel> = [];
  public isBusy = false;
  public isLoading = false;
  public newSlideContent = '';
  public newSlideImage: any = {};
  public newSlidePath = '';
  public isAdding = false;

  public constructor(private mApiService: ApiService, private mMessageService: MessageService) {

  }

  ngOnInit(): void {
    this.isLoading = true;
    this.mApiService.get<Array<SlideModel>>("/api/admin/common/slider").subscribe({
      next: r => {
        this.slides = r;
        this.isLoading = false;
      }, error: () => this.isLoading = false
    })
  }

  public save() {
    this.isBusy = true;
    this.mApiService.put('/api/admin/common/slider/save', this.slides).subscribe({
      next: () => {
        this.isBusy = false;
        this.mMessageService.addMessage({
          type: this.mMessageService.types.success,
          text: 'Слайды сохранены'
        });
      },
      error: () => this.isBusy = false
    },);
  }

  public saveNewSlide() {
    const formData = new FormData();
    formData.append('file', this.newSlideImage);
    formData.append('content', this.newSlideContent);

    this.isAdding = true;

    this.mApiService.formData<SlideModel>('/api/admin/common/slider/add', formData).subscribe({
      next: (r: SlideModel) => {
        this.slides.push(r);
        this.isAdding = false;
        this.newSlideImage = {};
        this.newSlidePath = '';
        this.newSlideContent = '';
        this.mMessageService.addMessage({
          type: this.mMessageService.types.success,
          text: 'Слайд добавлен'
        });
      },
      error: () => this.isAdding = false
    });
  }

  public selectFile(event: any) {
    if (!event.target.files[0]) {
      return;
    }

    this.newSlideImage = event.target.files[0];
    this.newSlidePath = URL.createObjectURL(this.newSlideImage);
  }

  public moveSlide(slide: SlideModel, toLeft: boolean) {

    let currentIndex = this.slides.findIndex(x => x.id === slide.id);

    let newIndex = currentIndex + (toLeft ? -1 : 1);

    if (newIndex < 0) {
      return;
    }

    if (newIndex >= this.slides.length) {
      return;
    }

    const swap = this.slides[newIndex];

    swap.order = currentIndex + 1;
    this.slides[currentIndex].order = newIndex + 1;

    this.slides[newIndex] = this.slides[currentIndex];
    this.slides[currentIndex] = swap;
  }

  public removeSlide(slide: SlideModel) {
    if (!confirm('Удалить слайд?')) {
      return;
    }

    this.slides.splice(this.slides.indexOf(slide), 1);
  }
}
